import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8a0096c0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a0096c0')) {
      api.createRecord('8a0096c0', component.options)
    } else {
      api.reload('8a0096c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8a0096c0&", function () {
      api.rerender('8a0096c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/appmain/index.vue"
export default component.exports